import script from "./background-remove.vue?vue&type=script&setup=true&lang=js"
export * from "./background-remove.vue?vue&type=script&setup=true&lang=js"

import "./background-remove.vue?vue&type=style&index=0&id=56ac97e1&lang=less"

const __exports__ = script;

export default __exports__